import type { WebViewIntent } from '@/lib/react-native/services/react-native.intent'
import { createIntent } from '@/lib/react-native/services/react-native.intent'

export function createProductListLoadingErrorIntent(error: string): WebViewIntent {
  return createIntent('PRODUCT_LIST_LOADING_ERROR', { error })
}

export function createProductListEventConditionsDrawerOpenIntent(): WebViewIntent {
  return createIntent('PRODUCT_LIST_EVENT_CONDITIONS_DRAWER_OPEN')
}
